<template>
  <div class="ipad-layout">
    <!-- 头部标题区域 -->
    <header class="screen-header">
      <div class="header-content">
        <div class="logo-section">
          <img src="@/assets/logo.png" alt="湖南新华" class="logo" />
          <h1 class="title">湖南新华实时数据大屏</h1>
        </div>
        <div class="time-section">
          <div class="current-time">{{ currentTime }}</div>
          <div class="last-update">最后更新: {{ lastUpdateTime }}</div>
        </div>
      </div>
    </header>

    <!-- 临时提示：条件为 true 时显示 -->
    <div v-if="showBrowserHint" class="browser-hint">请在电脑浏览器端打开页面</div>

    <!-- 主要内容区域 - iPad端两栏布局 -->
    <main class="screen-main">
      <!-- 左侧区域 -->
      <section class="left-section">
        <div class="module-container">
          <TodaySales />
        </div>
        <div class="module-row">
          <div class="module-container half">
            <BookStatistics />
          </div>
          <div class="module-container half">
            <TextbookStatistics />
          </div>
        </div>
        <div class="module-container map-container">
          <HunanMap />
        </div>
      </section>

      <!-- 右侧区域 -->
      <section class="right-section">
        <div class="module-row">
          <div class="module-container half">
            <ChannelSales />
          </div>
          <div class="module-container half">
            <OrderComparison />
          </div>
        </div>
        <div class="module-container">
          <MemberTrend />
        </div>
        <div class="module-row">
          <div class="module-container half">
            <SalesCategory />
          </div>
          <div class="module-container half">
            <CityChannelComparison />
          </div>
        </div>
      </section>
    </main>

    <!-- 加载遮罩 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner">
        <div class="spinner"></div>
        <div class="loading-text">数据加载中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BookStatistics from '@/components/Modules/BookStatistics.vue'
import ChannelSales from '@/components/Modules/ChannelSales.vue'
import SalesCategory from '@/components/Modules/SalesCategory.vue'
import TodaySales from '@/components/Modules/TodaySales.vue'
import HunanMap from '@/components/Modules/HunanMap.vue'
import MemberTrend from '@/components/Modules/MemberTrend.vue'
import TextbookStatistics from '@/components/Modules/TextbookStatistics.vue'
import OrderComparison from '@/components/Modules/OrderComparison.vue'
import CityChannelComparison from '@/components/Modules/CityChannelComparison.vue'

export default {
  name: 'IPadLayout',
  components: {
    BookStatistics,
    ChannelSales,
    SalesCategory,
    TodaySales,
    HunanMap,
    MemberTrend,
    TextbookStatistics,
    OrderComparison,
    CityChannelComparison
  },
  props: {
    currentTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showBrowserHint: true
    }
  },
  computed: {
    ...mapState(['loading', 'lastUpdateTime'])
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.ipad-layout {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #0c1426 0%, #1a2332 50%, #0c1426 100%);
  color: #ffffff;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  overflow: hidden;
  position: relative;

  .browser-hint {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000000;
    background: #fff;
    color: #ff9a57;
    font-size: 16px;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 头部样式
  .screen-header {
    height: 70px;
    background: linear-gradient(90deg, rgba(24, 144, 255, 0.1) 0%, rgba(24, 144, 255, 0.05) 100%);
    border-bottom: 2px solid rgba(24, 144, 255, 0.3);
    display: flex;
    align-items: center;
    padding: 0 30px;
    flex-shrink: 0;

    .header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo-section {
        display: flex;
        align-items: center;
        gap: 15px;

        .logo {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }

        .title {
          font-size: 26px;
          font-weight: bold;
          background: linear-gradient(45deg, #1890ff, #52c41a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin: 0;
          text-shadow: 0 0 20px rgba(24, 144, 255, 0.5);
          white-space: nowrap;
        }
      }

      .time-section {
        text-align: right;

        .current-time {
          font-size: 20px;
          font-weight: bold;
          color: #1890ff;
          text-shadow: 0 0 10px rgba(24, 144, 255, 0.5);
          margin-bottom: 3px;
        }

        .last-update {
          font-size: 12px;
          color: #8c8c8c;
        }
      }
    }
  }

  // 主要内容区域 - iPad端两栏布局
  .screen-main {
    height: calc(100vh - 70px);
    display: flex;
    padding: 15px;
    gap: 15px;

    .left-section,
    .right-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    .module-container {
      background: linear-gradient(135deg, rgba(24, 144, 255, 0.1) 0%, rgba(24, 144, 255, 0.05) 100%);
      border: 1px solid rgba(24, 144, 255, 0.3);
      border-radius: 6px;
      padding: 15px;
      backdrop-filter: blur(10px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      flex: 1;
      min-height: 150px;
      overflow: hidden;

      &.map-container {
        flex: 2;
        min-height: 300px;
      }

      &.half {
        flex: 1;
        min-height: 120px;
      }
    }

    .module-row {
      display: flex;
      gap: 15px;
      flex: 0 0 auto;

      .module-container {
        margin: 0;
      }
    }
  }

  // 加载遮罩样式
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .loading-spinner {
      text-align: center;

      .spinner {
        width: 40px;
        height: 40px;
        border: 3px solid rgba(24, 144, 255, 0.3);
        border-top: 3px solid #1890ff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 15px;
      }

      .loading-text {
        color: #1890ff;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  // 横屏适配
  @media screen and (orientation: landscape) {
    .screen-main {
      .left-section,
      .right-section {
        .module-container {
          min-height: 120px;

          &.map-container {
            min-height: 250px;
          }

          &.half {
            min-height: 100px;
          }
        }
      }
    }
  }

  // 竖屏适配
  @media screen and (orientation: portrait) {
    .screen-main {
      flex-direction: column;
      
      .left-section,
      .right-section {
        flex: 1;
        
        .module-container {
          min-height: 100px;

          &.map-container {
            min-height: 200px;
          }

          &.half {
            min-height: 80px;
          }
        }
      }
    }
  }
}
</style>